import { render, staticRenderFns } from "./modal-watsons-terms-and-conditions.vue?vue&type=template&id=060f9680"
import script from "./modal-watsons-terms-and-conditions.vue?vue&type=script&lang=js"
export * from "./modal-watsons-terms-and-conditions.vue?vue&type=script&lang=js"
import style0 from "./modal-watsons-terms-and-conditions.vue?vue&type=style&index=0&id=060f9680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports